export default {

	cache: {},

	put: function(key, value) {
		this.cache[key] = value;
	},

	get: function(key) {
		return this.cache[key];
	},

	has: function (key) {
		if(!this.cache) return false;
        return Object.prototype.hasOwnProperty.call(this.cache, key);
	},

	resolve: function (key, callback) {

		if(!this.has(key)) {
			this.put(key, callback());
		}

		return this.get(key);

	}

}
